import React from 'react';
import ChartLegend from './ChartLegend';
import Chart from 'react-apexcharts';

/**
 * Accepts an array of labels for the x axis, and a series array.
 * The series array should contain data for 2 lines. It should look like this:
 * [{
 *   name: 'Series 1 name,
 *   data: [1, 2, 3, 4]
 * }, {
 *   name: 'Series 2 name,
 *   data: [4, 5, 6, 7]
 * }]
 * @param {Array} xAxisLabels [2012, 2013, 2014]
 * @param {Array} series [{ name: 'Series 1', data: [1, 2, 3, 4] }]
 * @returns 
 */
export default function TwoLinesVolumeChart(_ref) {
  let {
    xAxisLabels,
    series,
    legendTitles
  } = _ref;
  const colors = ['#e6f1f8', '#80bbdc'];
  const optionsnewslatter = {
    chart: {
      toolbar: {
        show: false
      }
    },
    grid: {
      show: true,
      borderColor: 'rgba(0, 0, 0, .2)',
      strokeDashArray: 3,
      xaxis: {
        lines: {
          show: true
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      }
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ['#666E7E'],
        fontFamily: 'Franklin Gothic Book, sans-serif'
      },
      background: {
        enabled: false
      },
      formatter: number => window.MARKET_CONSTANTS.CURRENCY_FORMATTER.format(number)
    },
    stroke: {
      curve: 'smooth',
      width: 2
    },
    colors,
    fill: {
      type: 'gradient',
      opacity: ['0.1', '0.1']
    },
    xaxis: {
      categories: xAxisLabels,
      labels: {
        show: true,
        style: {
          colors: '#666E7E',
          fontSize: '14px',
          fontFamily: 'Franklin Gothic Book, sans-serif'
        }
      }
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          colors: '#666E7E',
          fontSize: '12px',
          fontFamily: 'Franklin Gothic Book, sans-serif'
        },
        formatter: number => window.MARKET_CONSTANTS.CURRENCY_FORMATTER.format(number)
      }
    },
    markers: {
      size: 3
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm'
      },
      theme: 'dark'
    },
    legend: {
      show: false
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChartLegend, {
    colors: colors,
    titles: legendTitles
  }), /*#__PURE__*/React.createElement("div", {
    className: "revenue",
    style: {
      height: '290px'
    }
  }, /*#__PURE__*/React.createElement(Chart, {
    options: optionsnewslatter,
    series: series,
    type: "area",
    height: "290px"
  })));
}